module.exports = __webpack_public_path__ + "static/media/preview.c2f30b14.svg";